import React from 'react';

export const AShapeBg = ({ className }) => (
  <svg className={`absolute -z-10 pointer-events-none opacity-5 ${className}`} viewBox="0 0 100 100" preserveAspectRatio="none">
    <polygon points="50,0 100,100 0,100" fill="currentColor" />
  </svg>
);

export const SwooshAccent = ({ className, color = "text-alpha-green" }) => (
  <svg className={`absolute pointer-events-none ${color} ${className}`} viewBox="0 0 1440 320" preserveAspectRatio="none" fill="none">
    <path 
      d="M0,160 C320,300 420,0 720,160 C1020,320 1120,50 1440,160" 
      stroke="currentColor" 
      strokeWidth="4" 
      strokeLinecap="round"
      className="opacity-50"
    />
  </svg>
);